import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, renderList as _renderList, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/icons/icon-phone.svg'
import _imports_1 from '@/assets/icons/icon-mail.svg'
import _imports_2 from '@/assets/icons/icon-sphere.svg'
import _imports_3 from '@/assets/icons/icon-address.svg'


const _hoisted_1 = { class: "contacts-details-header" }
const _hoisted_2 = { class: "breadcrumb-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "badge badge--breadcrumbs waitlist"
}
const _hoisted_4 = {
  key: 0,
  class: "button-wrapper"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "spinner"
}
const _hoisted_7 = {
  key: 2,
  class: "card"
}
const _hoisted_8 = { class: "content-details-wrapper" }
const _hoisted_9 = { class: "block-contact-information" }
const _hoisted_10 = { class: "block-contact-information_header" }
const _hoisted_11 = {
  key: 0,
  class: "avatar"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "user-info--name" }
const _hoisted_14 = { class: "contact-information-wrapper" }
const _hoisted_15 = {
  key: 0,
  class: "row-information"
}
const _hoisted_16 = { class: "row-information__text" }
const _hoisted_17 = {
  key: 1,
  class: "row-information"
}
const _hoisted_18 = { class: "row-information__text email" }
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 2,
  class: "row-information"
}
const _hoisted_21 = { class: "row-information__text" }
const _hoisted_22 = {
  key: 3,
  class: "row-information"
}
const _hoisted_23 = { class: "row-information__text" }
const _hoisted_24 = { class: "block-switch" }
const _hoisted_25 = { class: "switch-item--text" }
const _hoisted_26 = {
  key: 0,
  class: "switch-count"
}
const _hoisted_27 = { class: "block-switch--container" }
const _hoisted_28 = { class: "block-switch--container block-switch--notes" }
const _hoisted_29 = { class: "block-switch--container" }
const _hoisted_30 = { class: "table-default request--table" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "text-semi-bold" }
const _hoisted_33 = { class: "text-semi-bold" }
const _hoisted_34 = {
  key: 1,
  class: "button attention"
}
const _hoisted_35 = {
  key: 2,
  class: "status capitalize eoi-status"
}
const _hoisted_36 = { class: "block-switch--container" }
const _hoisted_37 = { class: "block-status" }
const _hoisted_38 = { class: "block-status-section block-status-documents" }
const _hoisted_39 = {
  key: 0,
  class: "row-information block-documents"
}
const _hoisted_40 = {
  key: 1,
  class: "row-information__text size-small color-muted"
}
const _hoisted_41 = { class: "block-status-section" }
const _hoisted_42 = {
  key: 0,
  class: "row-information"
}
const _hoisted_43 = {
  key: 1,
  class: "lot-preferences--wrapper"
}
const _hoisted_44 = { class: "lot-preferences--item" }
const _hoisted_45 = { class: "lot-preferences--row" }
const _hoisted_46 = { class: "lot-preferences--value" }
const _hoisted_47 = { class: "lot-preferences--row" }
const _hoisted_48 = { class: "lot-preferences--value" }
const _hoisted_49 = { class: "block-status-section" }
const _hoisted_50 = {
  key: 0,
  class: "row-information"
}
const _hoisted_51 = { class: "lot--container" }
const _hoisted_52 = { class: "lot-preferences--row" }
const _hoisted_53 = { class: "lot-preferences--value" }
const _hoisted_54 = { class: "lot-preferences--row" }
const _hoisted_55 = { class: "lot-preferences--value" }
const _hoisted_56 = { class: "lot-preferences--row" }
const _hoisted_57 = { class: "lot-preferences--value buyer-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode($setup["Breadcrumbs"], {
          crumbs: $setup.crumbs,
          backButton: true
        }, null, 8, ["crumbs"]),
        ($setup.inWaitList)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Waitlist"))
          : _createCommentVNode("", true)
      ]),
      (!$setup.deletedUser && $setup.userInfo?.detailsId && !$setup.isCollaborator($setup.estate))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            ($setup.inWaitList)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "button default primary",
                  onClick: $setup.openRemoveModal
                }, "Remove from waitlist"))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("button", {
                    class: "button default primary",
                    onClick: $setup.openWaitlistModal
                  }, "Add to waitlist"),
                  _createElementVNode("button", {
                    class: "button default primary",
                    onClick: $setup.inviteToWaitlist,
                    disabled: $setup.disableInvite
                  }, "Invite to waitlist", 8, _hoisted_5)
                ], 64))
          ]))
        : _createCommentVNode("", true)
    ]),
    ($setup.deletedUser)
      ? (_openBlock(), _createBlock($setup["DeletedUserBlock"], { key: 0 }))
      : ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : ($setup.userInfo?.detailsId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (!$setup.userInfo?.avatar)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString($setup.initials), 1))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "avatar",
                          src: $setup.userInfo?.avatar
                        }, null, 8, _hoisted_12)),
                    _createElementVNode("div", _hoisted_13, _toDisplayString($setup.fullName), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["badge", $setup.getContactStatusClass($setup.userStatus)])
                    }, _toDisplayString($setup.userStatus || "Prospect"), 3)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "card-subtitle-bold" }, "Contact Information", -1)),
                    ($setup.userInfo?.phone)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_0 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_16, _toDisplayString($setup.userInfo?.phone), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.userInfo?.email)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_1 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("span", null, _toDisplayString($setup.userInfo?.email), 1),
                            (!$setup.userInfo?.verifiedEmail)
                              ? _withDirectives((_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: require('@/assets/icons/icon-info.svg'),
                                  alt: "info"
                                }, null, 8, _hoisted_19)), [
                                  [_directive_tippy, { content: 'Email has not been verified yet.', theme: 'light-border', placement: 'top' }]
                                ])
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.userInfo?.detailsId?.postcode || $setup.userInfo?.detailsId?.state)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_2 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_21, _toDisplayString($setup.userInfo?.detailsId?.postcode
? $setup.userInfo?.detailsId?.postcode
: $setup.userInfo?.detailsId?.state), 1)
                        ]))
                      : _createCommentVNode("", true),
                    ($setup.userInfo?.detailsId?.address)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-information__icon" }, [
                            _createElementVNode("img", { src: _imports_3 })
                          ], -1)),
                          _createElementVNode("div", _hoisted_23, _toDisplayString($setup.userInfo?.detailsId?.address), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode($setup["SwitchComponent"], {
                    modelValue: $setup.currentTab,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.currentTab) = $event)),
                    list: $setup.tabs,
                    customSwitches: ['active'],
                    slots: ['customSwitch']
                  }, {
                    customSwitch: _withCtx((item) => [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(item.label === "REQUESTS" ? "CONTRACT FORMS" : item.label), 1),
                      (item.label === 'REQUESTS')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($setup.requests.length), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createVNode($setup["Payments"])
                  ], 512), [
                    [_vShow, $setup.currentTab.label === 'PAYMENTS']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_28, [
                    _createVNode($setup["Notes"])
                  ], 512), [
                    [_vShow, $setup.currentTab.label === 'NOTES']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_29, [
                    _createElementVNode("table", _hoisted_30, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.requests, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item._id,
                            onClick: ($event: any) => ($setup.onRow(item))
                          }, [
                            _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", _hoisted_32, "Lot " + _toDisplayString(item?.lotId?.title), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString([$setup.getName(item?.buyersData?.firstBuyer?.firstName, item?.buyersData?.firstBuyer?.lastName), $setup.getName(item?.buyersData?.secondBuyer?.firstName, item?.buyersData?.secondBuyer?.lastName)].filter((n) => n).join(", ")), 1),
                            _createElementVNode("td", null, [
                              (item.status === $setup.EoiStatus.PENDING)
                                ? (_openBlock(), _createBlock($setup["LotApproveButton"], {
                                    key: 0,
                                    lot: $setup.lotInfo(item),
                                    disabled: $setup.isApproving,
                                    onConfirm: $setup.onConfirmLot,
                                    onLoading: _cache[1] || (_cache[1] = ($event: any) => ($setup.isApprovLoading = true))
                                  }, null, 8, ["lot", "disabled"]))
                                : (item.status === $setup.EoiStatus.WITHDRAWN)
                                  ? (_openBlock(), _createElementBlock("button", _hoisted_34, "Withdrawn"))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString($setup.getLandownerEoiStatus(item.status)), 1))
                            ])
                          ], 8, _hoisted_31))
                        }), 128))
                      ])
                    ])
                  ], 512), [
                    [_vShow, $setup.currentTab.label === 'REQUESTS']
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_36, [
                    _createVNode($setup["LotDocuments"], {
                      tab: $setup.DocumentTypeEnum.CONTRACTS,
                      lot: { contracts: $setup.contracts },
                      isAdmin: "",
                      inner: ""
                    }, null, 8, ["tab", "lot"])
                  ], 512), [
                    [_vShow, $setup.currentTab.label === 'CONTRACTS']
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-subtitle-bold" }, "Documents", -1)),
                    ($setup.documents.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.documents, (item, index) => {
                            return (_openBlock(), _createBlock($setup["DocumentItem"], {
                              class: "block-documents--item",
                              key: index,
                              link: item.link,
                              name: item.name
                            }, null, 8, ["link", "name"]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_40, "No uploaded documents yet"))
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "card-subtitle-bold" }, "Lot preferences", -1)),
                    (!$setup.lotPrferences?._id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("div", { class: "row-information__text size-small color-muted" }, "No lot preferences yet", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "lot-preferences--title" }, "Lot size, m2:", -1)),
                              _createElementVNode("p", _hoisted_46, _toDisplayString($setup.formatPrice($setup.lotPrferences.lotSize?.from, false)) + " - " + _toDisplayString($setup.formatPrice($setup.lotPrferences.lotSize?.to, false)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_47, [
                              _cache[10] || (_cache[10] = _createElementVNode("p", { class: "lot-preferences--title" }, "Budget:", -1)),
                              _createElementVNode("p", _hoisted_48, _toDisplayString($setup.formatPrice($setup.lotPrferences.budget?.from)) + " - " + _toDisplayString($setup.formatPrice($setup.lotPrferences.budget?.to)), 1)
                            ])
                          ])
                        ]))
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "card-subtitle-bold" }, "Assigned lots", -1)),
                    ($setup.usersLotsArray.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("div", { class: "row-information__text size-small color-muted" }, "No lots assigned yet", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.usersLotsArray, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "lot--wrapper",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_52, [
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "lot-preferences--title" }, "Lot Number:", -1)),
                            _createElementVNode("p", _hoisted_53, [
                              _createVNode(_component_router_link, {
                                class: "lot-preferences--value-link",
                                to: { name: 'LotActions', params: { stageId: item.lot.stageId, lotId: item.lot.id } }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.lot.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _cache[14] || (_cache[14] = _createElementVNode("p", { class: "lot-preferences--title lot-preferences--title-type" }, "Current Status:", -1)),
                            _createElementVNode("p", _hoisted_55, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["badge", $setup.getDisplayStatusClass(item.lot.status)])
                              }, _toDisplayString(item.lot.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : item.lot.status), 3)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _cache[15] || (_cache[15] = _createElementVNode("p", { class: "lot-preferences--title" }, "Buyer Type:", -1)),
                            _createElementVNode("p", _hoisted_57, _toDisplayString(item?.eoi?.buyerType || "-"), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createVNode($setup["AddToWeitlistModal"], {
                "is-open": $setup.isOpenWaitlistModal,
                onClose: $setup.closeWaitlistModal,
                onConfirm: $setup.onConfirmWaitlistModal,
                disabled: !$setup.lotsArray || $setup.lotsArray.length === 0,
                lotsArray: $setup.lotsArray,
                payload: $setup.params
              }, null, 8, ["is-open", "disabled", "lotsArray", "payload"]),
              _createVNode($setup["RemoveFromWeitlistModal"], {
                "is-open": $setup.isOpenRemoveModal,
                onClose: $setup.closeRemoveModal,
                onConfirm: $setup.onConfirmRemoveModal,
                subscriptionId: $setup.lotPrferences?._id || ''
              }, null, 8, ["is-open", "subscriptionId"])
            ]))
          : _createCommentVNode("", true)
  ], 64))
}